import { useElementSize } from "usehooks-ts";

import { useMetricsExplorerContext } from "@features/metrics-explorer/hooks";
import { type QuickSelectOption } from "@features/metrics-explorer/types";

import { AddMetricButton } from "./add-metric-button";
import { MetricCardList } from "./metric-card-list";

interface Props {
  hideAddButton?: boolean;
  onAddTile: () => void;
  onQuickSelect: (value: QuickSelectOption) => void;
}

export const MetricCards = ({
  hideAddButton,
  onAddTile,
  onQuickSelect,
}: Props) => {
  const { metricsData } = useMetricsExplorerContext();

  const [metricsContainerRef, { width: metricsContainerWidth }] =
    useElementSize();
  const metricCardWidth =
    metricsContainerWidth / Math.floor(metricsContainerWidth / (256 + 12)) - 10;

  return (
    <>
      {metricsData.length > 0 && (
        <div ref={metricsContainerRef} className="flex flex-wrap gap-3 mb-6">
          <MetricCardList metricCardWidth={metricCardWidth} />
          {!hideAddButton && (
            <div className="__hide-on-pdf-export">
              <AddMetricButton
                width={metricCardWidth}
                onAddTile={onAddTile}
                onQuickSelect={onQuickSelect}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
